module.exports = __webpack_public_path__ + "static/uv-be03337efd23a7b7d2a6b51d0c044247.png";